import React, { FC, PropsWithChildren, memo } from 'react';

import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

interface Props extends PropsWithChildren {
  title: string;
}

const Card: FC<Props> = ({ children, title }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="h4" color={(theme) => theme.primary.p2}>
        {title}
      </Typography>
      {children}
    </div>
  );
};

export default memo(Card);
